import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getUssdTransactions,
  getMoreUssdTransactions,
} from "redux/actions/transActions";
import moment from "moment";
import { formatNumberAmount } from "helpers/utilFunctions";
import { Box, Link, Text } from "@chakra-ui/react";
import { popLastId } from "helpers/utilFunctions";
import { DateTimeFormat } from "../../constants";
import { Table } from "antd";
import { Loader } from "components/common";
import { RootState } from "types";

const columns = [
  {
    dataIndex: "transactionAmount",
    key: "transactionAmount",
    render: (text: string) => (
      <Box>
        <Text fontSize={{ base: "xx-small", md: "xs" }} fontWeight="bold">
          {text}
        </Text>
        <Text fontSize={{ base: "xx-small" }} fontWeight="normal">
          Amount
        </Text>
      </Box>
    ),
  },
  {
    dataIndex: "transactionDate",
    key: "transactionDate",
    render: (text: string) => (
      <Box>
        <Text fontSize={{ base: "xx-small", md: "xs" }} fontWeight="bold">
          {text}
        </Text>
        <Text fontSize={{ base: "xx-small" }} fontWeight="normal">
          Date
        </Text>
      </Box>
    ),
  },
  {
    dataIndex: "sessionId",
    key: "sessionId",
    render: (text: string) => (
      <Box>
        <Text fontSize={{ base: "xx-small", md: "xs" }} fontWeight="bold">
          {text}
        </Text>
        <Text fontSize={{ base: "xx-small" }} fontWeight="normal">
          Session ID
        </Text>
      </Box>
    ),
    className: "table-cell-display table-cell-display--md",
  },
  {
    dataIndex: "phoneNumber",
    key: "phoneNumber",
    render: (text: string) => (
      <Box>
        <Text fontSize={{ base: "xx-small", md: "xs" }} fontWeight="bold">
          {text}
        </Text>
        <Text fontSize={{ base: "xx-small" }} fontWeight="normal">
          Phone number
        </Text>
      </Box>
    ),
    className: "table-cell-display table-cell-display--md",
  },
  {
    dataIndex: "status",
    key: "status",
    render: (text: string) => (
      <Box>
        <Text fontSize={{ base: "xx-small", md: "xs" }} fontWeight="bold">
          {text}
        </Text>
        <Text fontSize={{ base: "xx-small" }} fontWeight="normal">
          Status
        </Text>
      </Box>
    ),
    className: "table-cell-display table-cell-display--md",
  },
];

export default function UssdTransactionsTable() {
  const dispatch = useDispatch();
  const transactionState = useSelector(
    (state: RootState) => state.transactionReducer
  );
  const setting = useSelector((state: RootState) => state.settingsReducer);
  const userSetting = setting?.settingData?.data;
  const accountId = userSetting?.apiCredentials?.id;
  //61512e41ac43b4002907ca32
  const transactions = transactionState?.ussdTransactionsData?.data;
  const loading = transactionState?.requestLoading;
  const [lastIds, setLastIds] = useState<(string | null)[]>([null]);
  const xJwt = localStorage.getItem("tx_jwt");

  useEffect(() => {
    if (accountId) {
      dispatch(getUssdTransactions(xJwt, accountId));
    }
  }, [dispatch, accountId, xJwt]);

  useEffect(() => {
    if (
      transactionState?.ussdTransactionsData !== undefined &&
      transactionState?.ussdTransactionsData?.lastId !== undefined
    ) {
      setLastIds([...lastIds, transactionState?.ussdTransactionsData?.lastId]);
    }
  }, [transactionState?.ussdTransactionsData]); //eslint-disable-line

  const loadNextPage = () => {
    dispatch(
      getMoreUssdTransactions(
        xJwt,
        accountId,
        transactionState?.ussdTransactionsData?.lastId
      )
    );
  };

  const loadPrevPage = () => {
    if (lastIds.length === 3) {
      dispatch(getUssdTransactions(xJwt, accountId));
      setLastIds([null]);
    } else {
      dispatch(
        getMoreUssdTransactions(xJwt, accountId, lastIds[lastIds.length - 3])
      );
      popLastId(lastIds, setLastIds);
    }
  };

  const data: any[] | undefined = [];
  if (transactions) {
    for (let i = 0; i < transactions.length; i++) {
      const transaction = transactions[i];
      const key = transaction?._id;
      const transactionAmount = formatNumberAmount(transaction?.totalCost);
      const transactionDate = moment(transaction?.createdAt).format(
        DateTimeFormat
      );
      const sessionId = transaction?._id;
      const phoneNumber = transaction?.productsDetails?.phoneNumber;
      const status = transaction?.frontendStatus;
      data.push({
        key,
        transactionAmount,
        transactionDate,
        sessionId,
        phoneNumber,
        status,
      });
    }
  }

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            defaultPageSize: 50,
            hideOnSinglePage: true,
            position: ["bottomLeft"],
          }}
        />
      )}
      <Box className="pagination-items">
        {lastIds.length <= 2 ? null : (
          <Link onClick={loadPrevPage} className="pagination-item-link prev">
            Previous page
          </Link>
        )}
        {!transactionState?.ussdTransactionsData?.isLastPage ? (
          <Link onClick={loadNextPage} className="pagination-item-link next">
            Next page
          </Link>
        ) : null}
      </Box>
    </>
  );
}
